.messageContainer {
  position: sticky;
  top: 0;
  z-index: 3;
}
